import { Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../services/storege-service/storage.service';
import { GlobalSettingsService } from '../../services/global-settings-service/global-settings.service';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-login',
  templateUrl: 'facilityList.component.html',
})
export class FacilityListComponent {
  @HostBinding('class') cAppClass = 'c-app flex-row align-items-center';

  public isLoading = false;
  public errMsg = '';
  public mobile = null;
  public password = null;
  public facilityId = null;
  public country = null;
  public isOwner = 'Y';
  public facilityList?;
  public countryList?;

  constructor(
    private router: Router,
    private storageSrv: StorageService,
    private localInterfaceSrv: LocalInterfaceService,
    private globalInterfaceSrv: GlobalSettingsService,
    public toolService: ToolService,
  ) {

  }

  async ngOnInit() {
    if (await this.storageSrv.isLoggedin()) {
      if (this.storageSrv.getType() == 'admin')
      {
        await this.loadCountries();
        await this.loadFacilities("BH");
        //this.goToDashboard();
      }
      else
      {
        this.goToLogin();
      }
    }
  }

  goToDashboard = () => {
    this.router.navigate(['/dashboard']);
  }

  goToLogin = () => {
    this.router.navigate(['/login']);
  }

  goToCalendar = () => {
    this.router.navigate(['/calendar']);
  }

  goToFacilityList = () => {
    this.router.navigate(['/facilityList']);
  }

  goToForceChangePassword = () => {
    this.router.navigate(['/change-password/']);
  }

  login = async () => {
    this.globalInterfaceSrv.removeGlobalSettings()
    if (await this.validateInput()) {
      this.isLoading = true;
      this.facilityList.content.forEach(async facility => {
        if (facility.id == this.facilityId)
        {
          this.storageSrv.setFacilityId(this.facilityId);
          this.storageSrv.setFacilityCcy(facility.ccy);
          this.storageSrv.setFacilityName(facility.facilityName);
          this.storageSrv.setFacilityPhoneNumber(facility.facilityNumber);
          this.storageSrv.setFacilityOfficialName(facility.officialName);
          this.storageSrv.setFacilityTaxNumber(facility.taxNumber);
          this.storageSrv.setCalendarTimeSlots(facility.calendarTimeSlots);
          await this.globalInterfaceSrv.loadGlobalSettings(this.facilityId)

        }
      });
      this.goToDashboard();
      this.isLoading = false;
    }
  }

  
  loadFacilities = (country) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getFacilitiesList(country)
      .then(res => {
        this.facilityList = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
      })
      .finally(
        () => {this.isLoading = false;}
      );
    });
  }

  loadCountries = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getCountriesList()
      .then(res => {
        this.countryList = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
      })
      .finally(
        () => {this.isLoading = false;}
      );
    });
  }

  validateInput() {
    return new Promise<any>((resolve) => {
      this.errMsg = '';
      if (!this.facilityId || this.facilityId === null || this.facilityId.trim() === '') {
        this.errMsg = 'Please select a facility';
        resolve(false);
      }
      else {
        resolve(true);  
      }
    });
  }
}
